import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  tableContainer: {
    width: '100%',
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.app.borderRadius.md,
    boxShadow: '8px 10px 15px 0px rgb(111 72 65 / 0.15)',
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    '& td': {
      padding: '16px 8px',
      fontSize: theme.app.typography.label.fontSize,
      color: '#513628',
      borderBottom: `1px solid ${theme.palette.background.tertiary.light}`
    },

    '& tbody tr': {
      transition: '.4s all ease',
      border: 'solid 1px transparent',
      borderLeftWidth: 2,
      borderRightWidth: 2,

      '&:nth-child(even)': {
        background: '#ececec'
      },

      '&:hover': {
        background: 'rgb(120, 74, 66, 0.1)',
        borderColor: theme.app.colors.border.dark,

        '& td': {
          borderTop: `solid 1px ${theme.app.colors.border.dark}`
        }
      },

      [theme.breakpoints.down('sm')]: {
        '&:hover': {
          // background: 'transparent !important',
          // borderColor: 'transparent !important',
          '& td': {
            borderTop: 'none !important'
          }
        }
      }
    },

    '@media (max-width:961px)': {
      '& tbody tr': {
        '&:nth-child(even)': {
          borderTop: `1px solid ${theme.palette.primary.main}`,
          borderBottom: `1px solid ${theme.palette.primary.main}`
        }
      }
    },

    [theme.breakpoints.down('sm')]: {
      '& table, thead, tbody, th, td, tr': {
        display: 'flex',
        flexDirection: 'column'
      },
      '& thead tr': {
        position: 'absolute',
        marginRight: 16,
        top: -9999,
        left: -9999
      },
      '& tr': {
        marginBottom: 20,
        background: '#fff',
        borderRadius: 0,
        boxShadow: 'none',
        padding: '12px 8px',
        borderTop: '1px solid #e0d6d0',
        borderBottom: '1px solid #e0d6d0',
        borderLeft: 'none',
        borderRight: 'none',
        transition: 'none'
      },

      '& :last-child': {
        [theme.breakpoints.down('sm')]: {
          marginBottom: 0
        }
      },

      '& td': {
        flexGrow: 1,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        display: 'flex',
        textAlign: 'start!important',
        padding: '10px 0 10px 0',
        border: 'none',
        background: 'none',
        fontSize: 15,
        color: '#513628',
        wordBreak: 'break-word',
        '&:first-child': {
          textAlign: 'center',
          borderTop: 'none'
        },
        '&:before': {
          textAlign: 'left',
          width: 'auto',
          minWidth: 110,
          marginRight: 10,
          display: 'inline-block',
          fontWeight: 700,
          color: theme.palette.primary.main,
          fontSize: theme.app.typography.label.fontSize,
          letterSpacing: 0.1,
          opacity: 0.95
        }
      }
    },

    [theme.breakpoints.up('md')]: {
      border: 'none',
      borderRadius: 0,
      '& table': {
        width: '100%',
        overflow: 'hidden',
        borderRadius: '9px 9px 0 0',
        fontSize: theme.app.typography.paragraph.fontSize,
        border: `1px solid ${theme.palette.secondary.main}`,
        tableLayout: 'fixed'
      },

      '& table, thead, tbody, th, td, tr': {
        textAlign: 'start',
        borderTop: 'none',
        borderBottom: 'none'
      },

      '& th': {
        fontSize: theme.app.typography.body.fontSize,
        fontWeight: 400,
        padding: '16px 8px',
        fontFamily: 'Roboto',
        background: theme.palette.background.other.main,
        color: theme.palette.background.other.contrastText
      },

      '& td': {
        '&:before': {
          display: 'none'
        }
      }
    }
  },

  notFoundItemsMsg: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: 250,
    padding: '48px 24px',
    background: 'linear-gradient(135deg, rgba(120, 74, 66, 0.02) 0%, rgba(120, 74, 66, 0.05) 100%)',
    borderRadius: '12px',
    margin: '16px',

    [theme.breakpoints.down('sm')]: {
      padding: '32px 20px',
      minHeight: 200,
      margin: '12px'
    }
  },

  emptyStateIcon: {
    marginBottom: 24,
    color: theme.palette.primary.main,
    opacity: 0.7,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',

    '&:hover': {
      transform: 'scale(1.05)',
      opacity: 0.9
    },

    '& svg': {
      filter: 'drop-shadow(0 2px 8px rgba(120, 74, 66, 0.1))'
    }
  },

  emptyStateContent: {
    maxWidth: 320
  },

  emptyStateTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,
    margin: '0 0 12px 0',
    letterSpacing: '-0.02em',

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.app.typography.h3.fontSize
    }
  },

  emptyStateDescription: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.palette.primary.main,
    margin: '0 0 8px 0',
    lineHeight: 1.6,
    opacity: 0.9,

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.app.typography.label.fontSize
    }
  },

  emptyStateSuggestion: {
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 400,
    color: theme.palette.primary.main,
    margin: 0,
    lineHeight: 1.5,
    opacity: 0.8,
    fontStyle: 'italic',

    [theme.breakpoints.down('sm')]: {
      fontSize: 13
    }
  },

  loadingContainer: {
    display: 'flex',
    minHeight: 250,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',

    [theme.breakpoints.down('sm')]: {
      minHeight: 200
    }
  },

  mobileHidden: {
    [theme.breakpoints.down('sm')]: {
      display: 'none !important'
    }
  },

  fullWidthCell: {
    '&::before': {
      display: 'none !important'
    },

    [theme.breakpoints.down('sm')]: {
      display: 'block !important',
      textAlign: 'center !important' as any
    }
  },

  noHoverEffect: {
    '& tbody tr': {
      '&:hover': {
        background: 'transparent !important',
        borderColor: 'transparent !important',

        '& td': {
          borderTop: 'none !important'
        }
      }
    }
  }
}))
